import React, { Component } from 'react';
import { 

    BrowserRouter as Router,
    Route,
    Link

} from "react-router-dom";



import BoostrapCss from 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/atul.css';

import JQuery from 'jquery/src/jquery';
import Boostrap from 'bootstrap/dist/js/bootstrap.min';

//componetnts
import Header from './components/header';
import Footer from './components/footer';
import HomePage from './pages/homePage';
import About from './pages/about';
import Product from './pages/product';
import Services from './pages/services';


class App extends Component {
  render() {
    return (
      <Router>
      <div className="App">
      <Header />
        <Route exact path='/' component={HomePage} />
        <Route exact path='/About' component={About} />
        <Route exact path='/Product' component={Product} />
        <Route exact path='/Services' component={Services} />
      <Footer />
      </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js